import React from "react";
import ProfileCard from "pages/Profile/components/ProfileCard";
import cx from "classnames";

interface Props {
  isEdit?: boolean;
}

const MediaSection = ({ isEdit }: Props) => {
  return (
    <div className="grid grid-cols-1 gap-6">
      <ProfileCard className={cx("aspect-video")} isEdit={isEdit} editBottom />
      <div className="grid grid-cols-2 gap-2">
        <ProfileCard className="flex flex-col gap-2 p-2">
          <div className="flex aspect-video h-[64px] items-center justify-center rounded-lg border border-white/5 bg-white/10">
            <span className="text-xs uppercase tracking-widest dark:text-white/20">
              Thumbnail
            </span>
          </div>

          <div className="flex flex-col gap-1">
            <h3 className="text-s font-semibold leading-tight dark:text-white">
              Theater Showreel 2024
            </h3>
            <span className="text-xs dark:text-white/60">4:15</span>
          </div>
        </ProfileCard>
        <ProfileCard className="flex flex-col gap-2 p-2">
          <div className="flex aspect-video h-[64px] items-center justify-center rounded-lg border border-white/5 bg-white/10">
            <span className="text-xs uppercase tracking-widest dark:text-white/20">
              Thumbnail
            </span>
          </div>

          <div className="flex flex-col gap-1">
            <h3 className="text-s font-semibold leading-tight dark:text-white">
              Theater Showreel 2024
            </h3>
            <span className="text-xs dark:text-white/60">4:15</span>
          </div>
        </ProfileCard>
      </div>
    </div>
  );
};

export default MediaSection;
